module.exports = __webpack_public_path__ + "img/integrationsEmptyScreenImage.04ef6d8e.png";